import { GlassPanel } from '@/components/glass/GlassPanel';
import { cn } from '@/lib/utils';

/**
 * `<JobRowCardSkeleton>` — UI-SPEC § 3.4 loading-state placeholder.
 *
 * Mirrors the JobRowCard anatomy with `animate-pulse` blocks: a status pill
 * placeholder, an address+meta two-line stack, and a 7-dot row (md+ only).
 * The skeleton is `aria-hidden` because the parent JobsList's `aria-busy`
 * attribute is the SR-friendly source of truth for the loading state.
 *
 * Reduced-motion: `animate-pulse` honors `prefers-reduced-motion` natively.
 */
export function JobRowCardSkeleton() {
  return (
    <GlassPanel
      variant="base"
      as="div"
      aria-hidden="true"
      className={cn(
        'max-w-[1100px] mx-auto min-h-[88px] p-4',
        'flex flex-col gap-3',
        'md:grid md:grid-cols-[120px_1fr_auto] md:gap-5 md:items-center md:p-5',
      )}
    >
      <div className="h-6 w-20 rounded-full bg-foam-50/10 animate-pulse" />
      <div className="flex flex-col gap-2">
        <div className="h-6 w-3/4 rounded bg-foam-50/10 animate-pulse" />
        <div className="h-4 w-1/2 rounded bg-foam-50/10 animate-pulse" />
      </div>
      <div className="hidden md:flex items-center gap-1">
        {Array.from({ length: 7 }).map((_, i) => (
          <div
            key={i}
            className="w-2 h-2 rounded-full bg-foam-50/10 animate-pulse"
          />
        ))}
      </div>
    </GlassPanel>
  );
}
